import React, { useEffect, useRef, useState } from 'react';
import {
  exportNotesAsMarkdown,
  exportNotesAsPDF,
  copyNotesToClipboard,
} from '../utils/noteExport';

function ExportMenu({ notes, paper, disabled }) {
  const [open, setOpen] = useState(false);
  const [justCopied, setJustCopied] = useState(false);
  const rootRef = useRef(null);

  // Close on outside click / Escape.
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const handle = async (action) => {
    setOpen(false);
    try {
      if (action === 'md') exportNotesAsMarkdown(notes, paper);
      else if (action === 'pdf') exportNotesAsPDF(notes, paper);
      else if (action === 'clipboard') {
        await copyNotesToClipboard(notes, paper);
        setJustCopied(true);
        setTimeout(() => setJustCopied(false), 1600);
      }
    } catch (e) {
      console.error('Export failed:', e);
      alert('Export failed: ' + (e.message || e));
    }
  };

  return (
    <div className="export-menu" ref={rootRef}>
      <button
        type="button"
        className="export-menu-trigger"
        disabled={disabled}
        onClick={() => setOpen(o => !o)}
        title="Export notes"
      >
        {justCopied ? '✓ Copied' : 'Export ▾'}
      </button>
      {open && (
        <div className="export-menu-dropdown" role="menu">
          <button type="button" role="menuitem" onClick={() => handle('md')}>
            <span className="export-icon">📝</span>
            <span>Markdown (.md)</span>
          </button>
          <button type="button" role="menuitem" onClick={() => handle('pdf')}>
            <span className="export-icon">📄</span>
            <span>PDF (.pdf)</span>
          </button>
          <button type="button" role="menuitem" onClick={() => handle('clipboard')}>
            <span className="export-icon">📋</span>
            <span>Copy to clipboard</span>
          </button>
        </div>
      )}
    </div>
  );
}

export default ExportMenu;
